import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import Buttons from "../../../components/Buttons/Buttons";

const SecondaryEmailsSection = ({
  secondaryEmails,
  newSecondaryEmail,
  error,
  onChangeNewEmail,
  onAddEmail,
  onDeleteEmail,
  onEditEmail,
  editingIndex,
  editingEmail,
  setEditingEmail,
  onSaveEditEmail,
  onCancelEditEmail,
}) => {
  return (
    <div className="secondary-emails-section">
      <div className="form-section-header" style={{ marginBottom: "12px" }}>
        <div className="form-section-header-left">
          <h4 className="form-section-title" style={{ fontSize: "14px" }}>Secondary Emails (Optional)</h4>
          <p className="form-section-subtitle" style={{ fontSize: "12px" }}>Add optional fallback email addresses for notifications.</p>
        </div>
      </div>

      <div className="secondary-emails-content">
        <div className="secondary-emails-input-group">
          <div className="secondary-email-input-wrapper">
            <MailOutlineIcon className="email-input-icon" />
            <input
              type="email"
              value={newSecondaryEmail}
              onChange={onChangeNewEmail}
              placeholder="Enter secondary email"
              aria-label="Secondary email"
              className="secondary-email-input"
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  onAddEmail();
                }
              }}
            />
          </div>
          <Buttons
            text="Add"
            type="button"
            variant="smallprimary"
            onClick={onAddEmail}
            icon={<AddIcon fontSize="small" />}
            style={{ height: "42px", minWidth: "80px" }}
          />
        </div>
        {error && <span className="error email-error">{error}</span>}

        {secondaryEmails.length > 0 && (
          <div className="secondary-emails-list">
            {secondaryEmails.map((email, index) => (
              <div key={email} className="secondary-email-item">
                {editingIndex === index ? (
                  <>
                    <input
                      type="email"
                      value={editingEmail}
                      onChange={(e) => setEditingEmail(e.target.value)}
                      aria-label="Edit secondary email"
                      className="secondary-email-edit-input"
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          onSaveEditEmail(index);
                        }
                      }}
                      autoFocus
                    />
                    <Buttons
                      className="save-edit-btn"
                      icon={<CheckIcon fontSize="small" />}
                      ariaLabel="Save email"
                      onClick={() => onSaveEditEmail(index)}
                    />
                    <Buttons
                      className="cancel-edit-btn"
                      icon={<CloseIcon fontSize="small" />}
                      ariaLabel="Cancel edit"
                      onClick={onCancelEditEmail}
                    />
                  </>
                ) : (
                  <>
                    <span className="secondary-email-text">{email}</span>
                    <div className="secondary-email-actions">
                      <Buttons
                        className="edit-email-btn"
                        icon={<EditIcon fontSize="small" />}
                        ariaLabel="Edit email"
                        onClick={() => onEditEmail(index)}
                      />
                      <Buttons
                        className="delete-email-btn"
                        icon={<CloseIcon fontSize="small" />}
                        ariaLabel="Remove secondary email"
                        onClick={() => onDeleteEmail(index)}
                      />
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SecondaryEmailsSection;
